import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  getAllBccUserAsync,
  updateBccUserAsync,
} from './bccUserStore/bccUserStoreSlice';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzMultiSelect from '../../../components/BuzzMultiSelect/BuzzMultiSelect';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  minHeight: 145,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export const userColumn = [
  { Header: 'User Name', accessor: 'name' },
  {
    Header: 'Role',
    accessor: 'role',
    Cell: (val) => {
      const { role } = val.cell.row.original;
      if (Array.isArray(role))
        return (
          <>
            {role.map((item) => {
              return <p>{item}</p>;
            })}
          </>
        );
      else return <>{role}</>;
    },
  },
  { Header: 'Email', accessor: 'email' },
  { Header: 'Mobile', accessor: 'mobile' },
  { Header: 'Status', accessor: 'status' },
  {
    Header: 'Action',
    accessor: '_id',
    Cell: (val) => {
      const payload = val.cell.row.original;

      const { _id, status, role } = payload;
      const [statuses, setStatuses] = React.useState(status);
      const [roles, setRoles] = React.useState(role);
      const [anchorEl, setAnchorEl] = React.useState(null);
      const dispatch = useDispatch();
      const [open1, setOpen1] = React.useState(false);
      const handleOpen1 = () => setOpen1(true);
      const handleClose1 = () => setOpen1(false);

      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };
      const ITEM_HEIGHT = 48;

      const handleUpdate = async () => {
        let payload = {
          id: _id,
          data: {
            status: statuses,
            role: roles,
          },
        };
        try {
          dispatch(updateBccUserAsync(payload))
            .unwrap()
            .then((res) => {
              toast.success(`User has been Updated successully!`);
              dispatch(
                getAllBccUserAsync({
                  params: { page: 1, limit: 10 },
                })
              );
              handleClose1();
            });
          handleClose();
        } catch (error) {
          toast.error('User not updated!');
        }
      };

      return (
        <Box display="flex">
          <Box width={80} fontSize={14}>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
                },
              }}>
              <MenuItem onClick={handleOpen1}>Update Data</MenuItem>
            </Menu>
          </Box>
          <Modal
            open={open1}
            onClose={handleClose1}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <>
              <CloseIcon />
              <Box sx={style}>
                <Typography variant="h4">
                  <Box fontWeight={'fontWeightMedium'}>Update User Details</Box>
                </Typography>
                <Box display={'flex'} my={2}>
                  <BuzzSelect
                    labelKey="label"
                    valueKey="value"
                    options={[
                      { label: 'Active', value: 'active' },
                      { label: 'In-active', value: 'inactive' },
                    ]}
                    placeholder="Status"
                    value={statuses}
                    onChange={(e) => setStatuses(e.target.value)}
                    size="small"
                  />
                  <Box mx={1} />

                  <BuzzMultiSelect
                    valueKey="value"
                    labelKey="label"
                    options={[
                      { label: 'bccSchoolAdmin', value: 'bccSchoolAdmin' },
                      {
                        label: 'bccDiscoveryAdmin',
                        value: 'bccDiscoveryAdmin',
                      },
                      { label: 'bccAtheneumAdmin', value: 'bccAtheneumAdmin' },
                      { label: 'bccAkademyAdmin', value: 'bccAkademyAdmin' },
                      {
                        label: 'bccAffiliateAdmin',
                        value: 'bccAffiliateAdmin',
                      },
                      {
                        value: 'bccTeenybeansAdmin',
                        label: 'BCC Teeny Beans Admin',
                      },
                      {
                        value: 'saleshubUser',
                        label: 'Saleshub User',
                      },
                    ]}
                    value={roles}
                    onChange={(e) => setRoles(e.target.value)}
                  />
                </Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleUpdate()}>
                  Update
                </Button>
              </Box>
            </>
          </Modal>
        </Box>
      );
    },
  },
];
